"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Check = _interopRequireDefault(require("@decisiv/iconix/lib/components/Check"));

var _Minus = _interopRequireDefault(require("@decisiv/iconix/lib/components/Minus"));

var _Message = _interopRequireDefault(require("../../components/Message"));

var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));

var _RequiredIcon = _interopRequireDefault(require("../RequiredIcon"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _elements = require("./elements");

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var marks = {
  radio: _elements.RadioCheckMark,
  checkbox: _Check.default
};
var validTypes = ['checkbox', 'radio'];

var BooleanInput = function BooleanInput(props, ref) {
  var ariaDescribedBy = props['aria-describedby'],
      className = props.className,
      disabled = props.disabled,
      id = props.id,
      required = props.required,
      requiredMessageProp = props.requiredMessage,
      label = props.label,
      readOnly = props.readOnly,
      size = props.size,
      status = props.status,
      inputRef = props.inputRef,
      indeterminate = props.indeterminate,
      providedType = props.type,
      warningMessage = props.warningMessage,
      rest = _objectWithoutProperties(props, ["aria-describedby", "className", "disabled", "id", "required", "requiredMessage", "label", "readOnly", "size", "status", "inputRef", "indeterminate", "type", "warningMessage"]);

  var type = !validTypes.includes(providedType) ? 'checkbox' : providedType;
  var uuid = (0, _useUniqueId.default)(id, 'input-');
  var text = (0, _react.useMemo)(function () {
    return (label || '').trim();
  }, [label]);
  var Mark = (0, _react.useMemo)(function () {
    return indeterminate && type === 'checkbox' ? _Minus.default : marks[type];
  }, [type, indeterminate]);
  var translate = (0, _useTranslations.default)();
  var requiredMessage = translate(requiredMessageProp, 'textField.requiredMessage');
  var warningMessageId = (0, _useUniqueId.default)(undefined, 'input-warning-', [warningMessage]);
  return _react.default.createElement(_elements.Container, {
    className: className,
    isDisabled: disabled,
    isRadio: type === 'radio',
    ref: ref,
    size: size,
    status: status,
    warningMessage: warningMessage,
    indeterminate: indeterminate
  }, _react.default.createElement("input", _extends({}, rest, {
    "aria-describedby": warningMessage ? "".concat(ariaDescribedBy || '', " ").concat(warningMessageId) : ariaDescribedBy,
    required: required,
    ref: inputRef,
    id: uuid,
    type: type // Checkbox/Radio inputs don't support read-only,
    // so we fake that state with styles and by disabling the input
    ,
    disabled: !!disabled || !!readOnly,
    readOnly: !!readOnly
  })), _react.default.createElement("label", {
    htmlFor: uuid,
    onClick: function onClick(event) {
      event.stopPropagation();
    }
  }, _react.default.createElement(_elements.StyledInput, null, _react.default.createElement(Mark, {
    size: size === 'small' ? 'small' : 'medium',
    "aria-hidden": true
  })), text && _react.default.createElement("span", null, text, required && _react.default.createElement(_Tooltip.default, {
    placement: "top",
    target: _react.default.createElement(_RequiredIcon.default, {
      marginTop: "-3px",
      "aria-label": requiredMessage
    })
  }, requiredMessage))), warningMessage && _react.default.createElement(_Message.default, {
    id: warningMessageId,
    intent: "warning"
  }, warningMessage));
};

var BooleanInputWithRef = (0, _react.forwardRef)(BooleanInput);
var _default = BooleanInputWithRef;
exports.default = _default;